import { RootState } from '../../reducers';

export const selector = (state: RootState) => state.sharedComponents.signIn;
